import "./wuw.css"

function Wuw(){
    return(
        <div idName="bodywuw">
       
      
    <body className="maxxa">
    
    <section >
    <img  className="wuwTop" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/logos%20marcar%2Flogowuwsolo.png?alt=media&token=7559c6f6-1e4a-4d45-a6da-b0bb56732d23" alt="imagen de back" />
      <br></br>
      <div class="container px-4 px-lg-5 mt-5">
            <div class="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
                <div class="col mb-5">
                  <div className="backMaxxa"> 
                    <div class="card h-100">
                        <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2Fz08.jpeg?alt=media&token=d31711f4-973f-4a0d-bbda-f922cb6a1da9" /> 
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">Z08
                            <p>Soporte Magnetico</p>
                            </h5>
                           
                           </div>
                        </div>
                        </div>  
                        
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="fotoProd"  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2FZ07.png?alt=media&token=1638fa71-b7c5-4d7f-9ba2-41afdac62c40" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">Z07
                            <p>Holder Sopapa</p>
                            </h5>
                           
                           </div>
                        </div>
                       
                        </div>
                    </div>
                </div>
                <div class="col mb-5">
                  <div className="backMaxxa"> 
                    <div class="card h-100">
                        <img className="fotoProd"  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2Fw05.jpeg?alt=media&token=23fdc785-a32c-47a0-89d3-33f41c62b826" /> 
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">W05
                            <p>Cargador Inalambrico</p>
                            </h5>
                           
                           </div>
                        </div>
                        </div>  
                        
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2Fx123.png?alt=media&token=2ed27b99-cb57-46cb-b7a4-77af613ac24d" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">X123
                            <p>Cable Type C a Lightning</p>
                            </h5>
                            
                           </div>
                        </div>
                       </div>
                       
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2Fx128%20c.jpeg?alt=media&token=3e085ccc-bc9a-4527-b9d7-2ce817040450" alt="imagen de back" />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">X128
                            <p></p>
                            Type C 2.4 A</h5>
                          
                           </div>
                        </div>
                       
                        </div>
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2Fx128%20c.jpeg?alt=media&token=3e085ccc-bc9a-4527-b9d7-2ce817040450" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">X166
                            <p>Micro Usb 2A</p>
                            </h5>
                          
                           </div>
                        </div>
                       </div>
                        
                    </div>
                </div><div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="fotoProd"  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2Fr116.jpeg?alt=media&token=96ee8850-95ab-4ff4-a164-f154904e1eb8" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">R116
                            <p>Cable Auxiliar</p>
                            </h5>
                            
                           </div>
                        </div>
                       
                        </div>
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2Fr38.jpg?alt=media&token=b3d46356-530c-47cd-8747-7fddaf162672" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">R38
                            <p>Auricuar Vinca Bluetooth</p>
                            </h5>
                           
                           </div>
                        </div>
                       
                        </div>
                    </div>
                </div>
             
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2FR149.jpg?alt=media&token=b7d19ab3-6989-44da-8162-fcbce6d42926" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">R149
                            <p>Auricular Vincha Bluetooth</p>
                            </h5>
                           
                           </div>
                        </div>
                       
                        </div>
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="fotoProd" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/wuw%2Ft22.png?alt=media&token=676890c2-c1de-41fe-a3d9-8a6386fe91e5" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">T22
                            <p>Car Charger con Cable</p>
                            </h5>
                           
                           </div>
                        </div>
                       
                        </div>
                    </div> 
                </div>
                                             
                </div>
                </div>      
    </section>
 </body>   

 </div>
    )
}

export default Wuw